import { GmpObjectStatus } from './types';

export const GMP_OBJECT_STATUS_NAME_BY_CODE: Record<GmpObjectStatus, string> = {
  [GmpObjectStatus.ACCEPTED]: 'Принята',
  [GmpObjectStatus.REJECTED]: 'Отказано в госрегистрации',
  [GmpObjectStatus.SUSPENDED]: 'Регистрация приостановлена',
  [GmpObjectStatus.TERMINATED]: 'Регистрация прекращена',
  [GmpObjectStatus.REGISTERED]: 'Зарегистрировано/Внесено в реестр',
  [GmpObjectStatus.CANCELED]: 'Отмена госрегистрации',
};
